import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "HeroRichText",
    component: () => (__SERVER__ ? require("./hero-rich-text-view") : import("./hero-rich-text-view"))
});

export default definition;
